<div class="check-in-adult">
  <section>
    <info-page-header label="Check-In" [sublabel]="sublabel()"></info-page-header>
    <div class="check-in-adult-content">
      <p class="text-check">
        Por favor, comprueba tus datos, asegúrate de que sean correctos y rellena los que faltan.
        Tus datos serán enviados a los Cuerpos de Seguridad del Estado para cumplir con la Normativa de Viajeros y se utilizarán para rellenar el contrato de arrendamiento con tu anfitrión.
      </p>
      <p class="text-mandatory">
        Todos los campos son obligatorios y serán validados por tu anfitrión.
      </p>

      <!-- DEBUG: Mostrar MRZ en JSON si test = true -->
      <div *ngIf="test && mrz" style="
      background-color: #f5f5f5;
      border: 2px solid #ddd;
      border-radius: 8px;
      padding: 16px;
      margin: 16px 0;
      font-family: monospace;
      overflow-x: auto;
    ">
        <h3 style="margin-top: 0; color: #333;">🔍 DEBUG MRZ</h3>
        <pre style="margin: 0; color: #333; background-color: #fff; padding: 12px; border-radius: 4px;">{{ mrz | json }}</pre>
      </div>
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="form__field">
          <label for="sexo">Género</label>
          <select id="sexo" formControlName="sexo" [class.is-invalid]="isFieldInvalid('sexo')">
            <option value="M">Hombre</option>
            <option value="F">Mujer</option>
          </select>
          @if (isFieldInvalid('sexo')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="nombre">Nombre</label>
          <input id="nombre" type="text" formControlName="nombre" [class.is-invalid]="isFieldInvalid('nombre')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('nombre')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="apellido1">Apellido 1</label>
          <input id="apellido1" type="text" formControlName="apellido1" [class.is-invalid]="isFieldInvalid('apellido1')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('apellido1')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="apellido2">Apellido 2</label>
          <input id="apellido2" type="text" formControlName="apellido2" [class.is-invalid]="isFieldInvalid('apellido2')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('apellido2')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="fechaNacimiento">Fecha de Nacimiento</label>
          <input id="fechaNacimiento" type="date" formControlName="fechaNacimiento" [class.is-invalid]="isFieldInvalid('fechaNacimiento')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('fechaNacimiento')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="direccion">Dirección</label>
          <input id="direccion" type="text" formControlName="direccion" [class.is-invalid]="isFieldInvalid('direccion')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('direccion')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="codigoPostal">Código Postal</label>
          <input id="codigoPostal" type="text" formControlName="codigoPostal" [class.is-invalid]="isFieldInvalid('codigoPostal')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('codigoPostal')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="nacionalidad">Nacionalidad</label>
          <select id="nacionalidad" formControlName="nacionalidad" [class.is-invalid]="isFieldInvalid('nacionalidad')">
            <option value="" disabled>Selecciona una nacionalidad</option>
            @for (country of countries; track country.iso3) {
              <option [value]="country.iso3">({{ country.iso3.toUpperCase() }}) {{ country.name_es }}</option>
            }
          </select>
          @if (isFieldInvalid('nacionalidad')) {
            <small class="form__error">Este campo es obligatorio.</small>
          }
        </div>

        <div class="form__field">
          <label for="pais">País de residencia</label>
          <select id="pais" formControlName="pais" [class.is-invalid]="isFieldInvalid('pais')">
            <option value="" disabled>Selecciona un país</option>
            @for (country of countries; track country.iso3) {
              <option [value]="country.iso3">{{ country.name_es }}</option>
            }
          </select>
          @if (isFieldInvalid('pais')) {
            <small class="form__error">Selecciona un país.</small>
          }
        </div>

        @if (isSpainSelected()) {
          <div class="form__field">
            <label for="provincia">Provincia</label>
            <select id="provincia" formControlName="provincia" [class.is-invalid]="isFieldInvalid('provincia')">
              <option value="" disabled>Selecciona una provincia</option>
              @for (province of provinces; track province.id) {
                <option [value]="province.id" translate="no" data-wg-notranslate>{{ province.name }} </option>
              }
            </select>
            @if (isFieldInvalid('provincia')) {
              <small class="form__error">Selecciona una provincia.</small>
            }
          </div>

          <div class="form__field">
            <label for="municipio">Municipio</label>
            <select id="municipio" formControlName="municipio" [class.is-invalid]="isFieldInvalid('municipio')">
              <option value="" disabled>Selecciona un municipio</option>
              @for (municipality of municipalities; track municipality.id) {
                <option [value]="municipality.id" translate="no" data-wg-notranslate>{{ municipality.name }}</option>
              }
            </select>
            @if (isFieldInvalid('municipio')) {
              <small class="form__error">Selecciona un municipio.</small>
            }
          </div>
        } @else {
          <div class="form__field">
            <label for="estado">Estado</label>
            <input id="estado" type="text" formControlName="estado" [class.is-invalid]="isFieldInvalid('estado')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('estado')) {
              <small class="form__error">Este campo es obligatorio.</small>
            }
          </div>

          <div class="form__field">
            <label for="ciudad">Ciudad</label>
            <input id="ciudad" type="text" formControlName="ciudad" [class.is-invalid]="isFieldInvalid('ciudad')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('ciudad')) {
              <small class="form__error">Este campo es obligatorio.</small>
            }
          </div>
        }

        <div class="form__field">
          <label for="email">Email</label>
          <input id="email" type="email" formControlName="email" [class.is-invalid]="isFieldInvalid('email')" translate="no" data-wg-notranslate/>
          @if (isFieldInvalid('email')) {
            <small class="form__error">
              {{ form.get('email')?.hasError('required') ? 'Este campo es obligatorio.' : 'Introduce un email válido.' }}
            </small>
          }
        </div>

        @if (age() >= 14) {
          <div class="form__field">
            <label for="tipoDocumento">Tipo Documento</label>
            <select id="tipoDocumento" formControlName="tipoDocumento" [class.is-invalid]="isFieldInvalid('tipoDocumento')">
              <option value="D" data-wg-notranslate>DNI</option>
              <option value="P">Pasaporte</option>
              <option value="N" data-wg-notranslate>NIE</option>
              <option value="I">Documento de Identidad</option>
            </select>
          </div>

          <div class="form__field">
            <label for="numeroDocumento">Nº Documento</label>
            <input id="numeroDocumento" type="text" formControlName="numeroDocumento" [class.is-invalid]="isFieldInvalid('numeroDocumento')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('numeroDocumento')) {
              <small class="form__error">
                {{
                  form.get('numeroDocumento')?.hasError('required')
                    ? 'Este campo es obligatorio.'
                    : 'Formato no válido.'
                }}
              </small>
            }
          </div>

          <div class="form__field">
            <label for="fechaCaducidad">Fecha de Caducidad</label>
            <input id="fechaCaducidad" type="date" formControlName="fechaCaducidad" [class.is-invalid]="isFieldInvalid('fechaCaducidad')" translate="no" data-wg-notranslate/>
          </div>

          <div class="form__field">
            <label for="fechaExpedicion">Fecha de Expedición</label>
            <input id="fechaExpedicion" type="date" formControlName="fechaExpedicion" [class.is-invalid]="isFieldInvalid('fechaExpedicion')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('fechaExpedicion')) {
              <small class="form__error">Este campo es obligatorio.</small>
            }
          </div>

          @if (this.shouldShowSoporteDocumento(form.get('tipoDocumento')?.value)) {
            <div class="form__field">
              <label for="soporteDocumento">Soporte Documento</label>
              <div class="soporte-doc-field">
                <input id="soporteDocumento" type="text" formControlName="soporteDocumento" [class.is-invalid]="isFieldInvalid('soporteDocumento')" translate="no" data-wg-notranslate/>
                <button type="button" class="info-button" (click)="openSoporteDocumentoInfo()" aria-label="Más información sobre Soporte Documento">
                  <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path d="M6.4375 9.51572L7.76357 4.8612L8.7246 1.62952C9.52746 -1.7999 1.21633 1.11257 0 1.98879L0.0975727 3.0174C1.20508 2.29782 5.39887 1.37603 4.56273 3.92351L4.18759 5.22385L4.18759 5.22385L2.27539 11.8095C1.47254 15.2389 9.78367 12.3265 11 11.4502L10.9024 10.4216C9.79515 11.1414 5.60136 12.0632 6.4375 9.51572Z" fill="#000000" fill-rule="evenodd" transform="translate(0 5.561)" />
                      <path d="M2.5 4.63415C3.88071 4.63415 5 3.59676 5 2.31707C5 1.03739 3.88071 0 2.5 0C1.11929 0 0 1.03739 0 2.31707C0 3.59676 1.11929 4.63415 2.5 4.63415Z" fill="#000000" fill-rule="evenodd" transform="translate(5 0)" />
                    </g>
                  </svg>
                </button>
              </div>
              @if (isFieldInvalid('soporteDocumento')) {
                <small class="form__error">Este campo es obligatorio.</small>
              }
            </div>
          }
        }

        @if (age() >= 18 && contractNecessary()) {
          <div class="form__field">
            <label for="tipoContrato">Motivo de la estancia</label>
            <select id="tipoContrato" formControlName="tipoContrato" [class.is-invalid]="isFieldInvalid('tipoContrato')">
              <option value="" disabled selected>Selecciona un motivo</option>
              @for (c of contractTypes; track c.id) {
                <option [value]="c.id">{{ c.name }}</option>
              }
            </select>
            @if (isFieldInvalid('tipoContrato')) {
              <small class="form__error">Selecciona un motivo.</small>
            }
          </div>
        }

        <!-- Botón principal -->
        <button
          type="submit"
          class="primary-btn"
          [disabled]="loading()"
          data-testid="check-in-form-submit"
        >
          {{ loading() ? 'Enviando...' : 'Siguiente' }}
        </button>
      </form>
    </div>
  </section>
</div>
